export default __webpack_public_path__ + "static/laravel_service_banner-af150956330d47ad2990b70d8949b7c2.svg";